import React, { useEffect, useState } from 'react'
import c from 'classnames'
import mark from 'images/souSouMark.svg'

// Left half of the Home promo row: 3 rotating Sou-Sou variants, copy verbatim from the design (Home.html).
export const VARIANTS = [
  { key: 'starfruit', sub: ['Sprinkle a likkle sou-sou', 'inna yuh chat'] },
  { key: 'mango', sub: ['Your people, one pot.', 'Every turn comes round.'] },
  { key: 'gold', sub: ['Pick your people. Pick your banker.', 'Everybody sees every draw.'] },
]

export const HEADLINE = 'Wah Yuh Chat Bout?'
export const CTA = 'Start a Sou-Sou'
export const ROTATE_MS = 7000

const citrus = (c1, c2, rind) => ({ '--c1': c1, '--c2': c2, '--rind': rind })

// Decoration per variant (CSS shapes and the starfruit mark), positions from the design
const DECO = {
  starfruit: (
    <>
      <i className='mark' style={{ left: -14, top: -18, width: 70, height: 70 }} />
      <i className='mark' style={{ left: '4%', bottom: -26, width: 48, height: 48 }} />
      <i className='mark' style={{ left: '58%', top: -22, width: 62, height: 62 }} />
      <i className='mark' style={{ right: 210, bottom: -26, width: 58, height: 58 }} />
      <i className='dots' />
    </>
  ),
  mango: (
    <>
      <i className='sun' />
      <i className='citrus' style={{ ...citrus('#FFC80A', '#FFF8E0', '#F8A805'), left: 26, top: -28, width: 68, height: 68 }} />
      <i className='citrus' style={{ ...citrus('#A2E070', '#F2FBEA', '#50B414'), left: 200, top: -38, width: 60, height: 60 }} />
      <i className='citrus' style={{ ...citrus('#FFC80A', '#FFF8E0', '#F8A805'), right: 230, top: -34, width: 60, height: 60 }} />
      <i className='citrus' style={{ ...citrus('#A2E070', '#F2FBEA', '#50B414'), right: 40, bottom: -34, width: 72, height: 72 }} />
    </>
  ),
  gold: (
    <>
      <i className='mark' style={{ left: 60, bottom: -24, width: 64, height: 64 }} />
      <i className='mark' style={{ left: '22%', top: -30, width: 50, height: 50 }} />
      <i className='mark' style={{ right: 300, top: -26, width: 58, height: 58 }} />
      <i className='mark' style={{ right: -16, bottom: -20, width: 72, height: 72 }} />
      <i className='dots' />
    </>
  ),
}

const SouSouPromo = ({ url }) => {
  const [index, setIndex] = useState(0)
  const [paused, setPaused] = useState(false)
  const href = url // already validated and normalised (trailing slash) by getSouSouUrl

  // Rotates every 7 s; pauses while hovered or focused; choosing a dot restarts the timer (the effect re-runs on index)
  useEffect(() => {
    if (paused) return undefined
    const timer = setTimeout(() => setIndex(i => (i + 1) % VARIANTS.length), ROTATE_MS)
    return () => clearTimeout(timer)
  }, [index, paused])

  return (
    <div
      className='souSouPromo'
      style={{ '--mark': `url(${mark})` }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      {VARIANTS.map((variant, i) => (
        <div
          key={variant.key}
          className={c('souSouSlide', variant.key, { on: i === index })}
          aria-hidden={i !== index}
        >
          <div className='deco' aria-hidden='true'>{DECO[variant.key]}</div>
          <div className='headline'>{HEADLINE}</div>
          <div className='sub'>{variant.sub.map(line => <span key={line}>{line}</span>)}</div>
          <a className='cta' href={href} tabIndex={i === index ? 0 : -1}>{CTA}</a>
        </div>
      ))}
      <div className='pager'>
        {VARIANTS.map((variant, i) => (
          <button
            key={variant.key}
            type='button'
            className={c({ on: i === index })}
            aria-label={`Banner ${i + 1}`}
            aria-current={i === index}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  )
}

export default SouSouPromo
